import updateFieldsAfterFreespins from "ags/commands/update-fields-after-freespins";
import { CloseCommand } from "slotworks/commands/comms/close-command";
import ExitFreespins from "slotworks/state-machine/standard/states/exit-freespins";
import Contract from "slotworks/utils/contracts/contract";

export default class AGSExitFreespins extends ExitFreespins {
    protected setupPrompt() {
        return Contract.empty();
    }

    protected showPrompt(): Contract<void> {
        return CloseCommand();
    }

    protected resetToTriggeringSpin() {
        return this.updateFields();
    }

    protected resetMatrix() {
        return Contract.empty();
    }

    protected updateFields() {
        updateFieldsAfterFreespins();
        return Contract.empty();
    }
}
